import appApi from "./api";

export const cotizacionUnidadMargenService = {
  get() {
    return appApi().get("cotizaciones/unidad/margenAceptable");
  },
};
